//#region IMPORT
import React, { useRef, useState } from 'react';
import TRA_NEW_05 from './TRA_NEW_05';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import {
  closeLoading,
  showLoading,
} from '../../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import useDelete from '../../../../../hooks/useDeleteN';
import {
  useDelete1,
  useSave1,
  useSearch1,
  useSearch2,
} from './TRA_NEW_05_QUERY';
import { useSave } from '../../../../../hooks/useSaveN';
import { TRA_NEW_05_Schema } from './TRA_NEW_05_Schema';
import usePartialRefresh from '../../../../../hooks/usePartialRefresh';
import { toPreviewSrc } from '../../../../../util';
//#endregion
const SCREEN_MENU_ID = 'TrainingPage';

function TRA_NEW_05F(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const rowClickData = useRef(null);
  //교육현황 그리드
  const gridRef1 = useRef();
  const [rowData1, setRowData1] = useState([]); // 교육현황 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육현황 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육현황 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]); // 교육현황 그리드 삭제 시 데이터
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  //참석자정보 그리드
  const gridRef2 = useRef();
  const [rowData2, setRowData2] = useState([]); // 참석자정보 그리드 데이터
  const [selectedRowData2, setSelectedRowData2] = useState([]); // 참석자정보 그리드 클릭 시 데이터
  const [changedRowData2, setChangedRowData2] = useState([]); // 참석자정보 그리드 변경 시 데이터
  const sessionCdRef = useRef(''); // 셀 클릭 시 tbmCd
  const [modalToggle1, setModalToggle1] = useState(false);
  //#endregion
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.employeeNo,
    getKeyFromResult: (result) => result.employeeNo,
  });
  const delete1 = useDelete1();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#region 조회
  //교육현황 조회(_value1:사업장코드)
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      setRowData1(rows);
    },
  });
  //참석장 정보 조회(value1: TBM코드)
  const { run: Search2, runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setRowData2(rows);
    },
  });

  //#endregion
  //#region 저장
  //교육현황 저장
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: TRA_NEW_05_Schema,
    getChangedRows: () => changedRowData1.filter((row) => !row.deleteYn),
    getDeletedRows: () => deletedRowData1,

    requestDelete: deleteHandler1.DeleteLogic,

    requestSave: (rows) => Save1Async(rows),

    onSuccessRefresh: async () => {
      ResetLogic1();
      await Search1();
    },
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#endregion
  //#region 나머지 함수
  // 이미지를 base64로 변환하는 함수
  const getBase64ImageSafe = async (url) => {
    try {
      if (!url || typeof url !== 'string' || url.trim() === '') {
        return null;
      }

      const fullUrl = url.startsWith('http')
        ? url
        : `${Global.file.useUrl}files/${fixUrl(url)}`;

      const response = await fetch(fullUrl, {
        method: 'GET',
        cache: 'no-cache',
      });

      if (!response.ok) {
        console.warn('파일 없음 또는 접근 불가:', fullUrl, response.status);
        return null;
      }

      // Content-Type 확인
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.startsWith('image/')) {
        console.warn('이미지 파일이 아님:', fullUrl, contentType);
        return null;
      }

      const blob = await response.blob();

      // Blob 크기 확인 (너무 큰 파일 방지)
      if (blob.size === 0) {
        console.warn('빈 파일:', fullUrl);
        return null;
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.warn('이미지 변환 오류:', e);
      return null;
    }
  };

  //인쇄 함수
  const PrintLogic1 = async () => {
    // 선택된 행 확인
    if (!selectedRowData1 || selectedRowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return Promise.resolve(); // Promise를 반환하여 finally가 실행되도록 함
    }

    dispatch(showLoading());
    let tableData = [];
    let attendeeTableData = []; // 참석자명단 테이블 데이터

    try {
      // 검색 연월 추출 (currentYear, currentMonth 사용)
      const currentYear = searchInfo?.currentYear;
      const currentMonth = searchInfo?.currentMonth;
      let year = '';
      let month = '';

      if (currentYear && currentMonth) {
        year = currentYear.toString();
        month = currentMonth.toString();
      } else {
        // 날짜가 없으면 현재 연월 사용
        const now = dayjs();
        year = now.format('YYYY');
        month = now.format('MM');
      }

      // 일자 포맷팅 함수 (YYYY-MM-DD)
      const FormatDate = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
      };

      // 시간 포맷팅 함수 (HH:mm)
      const FormatTime = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
      };

      // 교육시간 포맷팅 함수 (시작시간 ~ 종료시간)
      const FormatEducationTime = (startTime, endTime) => {
        const start = FormatTime(startTime);
        const end = FormatTime(endTime);

        if (!start && !end) return '';
        if (start && end) return `${start} ~ ${end}`;
        if (start) return start;
        if (end) return end;
        return '';
      };

      // 부서명 조합 함수 (DEP_NM1, DEP_NM2, DEP_NM3, DEP_NM4 중 가장 하위 부서명)
      const getDepartmentName = (dep) => {
        if (dep?.depNm4 && dep.depNm4.trim() !== '') return dep.depNm4;
        if (dep?.depNm3 && dep.depNm3.trim() !== '') return dep.depNm3;
        if (dep?.depNm2 && dep.depNm2.trim() !== '') return dep.depNm2;
        if (dep?.depNm1 && dep.depNm1.trim() !== '') return dep.depNm1;
        if (dep?.depNm && dep.depNm.trim() !== '') return dep.depNm;
        return '';
      };

      // 경로에서 파일명만 추출 (비디오/도면/플랜 표시용)
      const fileNameOnly = (path) => {
        if (!path || typeof path !== 'string') return '';
        const parts = path.replace(/\\/g, '/').split('/');
        return parts.pop() || '';
      };

      // 첫 번째 항목의 회의일시와 회의장소 추출 (HeaderData용)
      let meetingYear = '';
      let meetingMonth = '';
      let meetingDay = '';
      let meetingStartTime = '';
      let meetingEndTime = '';
      let firstMeetingAddress = '';
      let headerTbmTitle = '';
      let headerTbmContent = '';
      let headerHostDepNm = '';
      let headerHostNm = '';
      let headerHostRank = '';
      let hostAffiliationNm = '';
      let headerVideoFileName = '';
      let headerFileFileName = '';
      let headerPlanFileName = '';
      if (selectedRowData1.length > 0 && selectedRowData1[0]) {
        const firstRow = selectedRowData1[0];
        if (firstRow.tbmDate) {
          const date = new Date(firstRow.tbmDate);
          if (!isNaN(date.getTime())) {
            meetingYear = date.getFullYear().toString().slice(-2); // 뒤 2자리만
            meetingMonth = (date.getMonth() + 1).toString().padStart(2, '0');
            meetingDay = date.getDate().toString().padStart(2, '0');
          }
        }
        meetingStartTime = FormatTime(firstRow.startDt);
        meetingEndTime = FormatTime(firstRow.endDt);
        firstMeetingAddress = firstRow.tbmAddress || '';
        headerTbmTitle = firstRow.tbmTitle || '';
        headerTbmContent = firstRow.tbmContent || '';
        headerHostDepNm = firstRow.hostDepNm || '';
        headerHostNm = firstRow.hostNm || '';
        headerHostRank = firstRow.hostRank || '';
        hostAffiliationNm = firstRow.hostAffiliationNm || '';
        headerVideoFileName = fileNameOnly(firstRow.videoPath);
        headerFileFileName = fileNameOnly(firstRow.filePath);
        headerPlanFileName = fileNameOnly(firstRow.planPath);
      }

      // 헤더용 호스트서명·회의사진 (Telerik: 파일경로 X, base64)
      let headerHostSignBase64 = '';
      let headerEntryPhotoBase64 = '';
      const firstForHeader = selectedRowData1[0];
      if (firstForHeader) {
        if (firstForHeader.hostSignPath) {
          try {
            const b64 = await getBase64ImageSafe(firstForHeader.hostSignPath);
            if (b64 && b64.startsWith('data:image/')) {
              headerHostSignBase64 = b64.replace(
                /^data:image\/[a-z]+;base64,/,
                ''
              );
            }
          } catch (e) {
            /* empty */
          }
        }
        if (firstForHeader.entryPath) {
          try {
            const b64 = await getBase64ImageSafe(firstForHeader.entryPath);
            if (b64 && b64.startsWith('data:image/')) {
              headerEntryPhotoBase64 = b64.replace(
                /^data:image\/[a-z]+;base64,/,
                ''
              );
            }
          } catch (e) {
            /* empty */
          }
        }
      }

      // selectedRowData1의 각 항목에 대해 반복하여 조회 및 인쇄
      for (let index = 0; index < selectedRowData1.length; index++) {
        const selectedRow = selectedRowData1[index];
        if (!selectedRow.sessionCd) continue;

        const sessionCd = selectedRow.sessionCd;
        const row = selectedRow;
        let attendeeListData = [];

        // useSearch2 훅의 runAsync를 사용하여 참석자 정보 조회
        const searchParams = {
          sessionCd: sessionCd,
        };
        const attendeeData = await Search2Async(
          searchParams,
          {} // onSuccess 콜백 없이 데이터만 반환받기 위해 빈 객체 전달
        );

        if (attendeeData && attendeeData.length > 0) {
          // 참석자 정보를 비동기로 처리하여 서명 사진을 base64로 변환
          const processedAttendees = await Promise.all(
            attendeeData.map(async (attendee) => {
              // 서명 사진 경로 확인 (FILE_PATH, SIGNATURE_PATH, CHECK_PATH 등)
              const signaturePath = attendee.signImagePath || '';

              // 서명 사진을 base64로 변환
              let signatureBase64 = '';
              if (signaturePath) {
                try {
                  const base64Full = await getBase64ImageSafe(signaturePath);
                  if (base64Full && base64Full.startsWith('data:image/')) {
                    signatureBase64 = base64Full.replace(
                      /^data:image\/[a-z]+;base64,/,
                      ''
                    );
                  }
                } catch (signatureError) {
                  /* empty */
                }
              }

              const affiliationNm = attendee.affiliationNm || '';
              const depNm = getDepartmentName(attendee) || '';
              const rank = attendee.rank || '';
              const userNm = attendee.userNm || '';
              const hostYn = attendee.hostYn || '';

              return {
                rank: rank,
                depNm: affiliationNm || depNm,
                userNm: userNm,
                signature: signatureBase64,
                hostYn: hostYn,
              };
            })
          );
          const processedForTable = processedAttendees.filter(
            (attendee) => attendee.hostYn !== 'Y'
          );
          // 참석자명단을 좌우로 분리
          const midPoint = Math.ceil(processedForTable.length / 2);
          const leftList = processedForTable.slice(0, midPoint); // 좌측
          const rightList = processedForTable.slice(midPoint); // 우측

          // 두 리스트 중 길이가 긴 값 기준으로 행 생성
          const maxLength = Math.max(leftList.length, rightList.length);

          // 참석자명단 테이블 데이터에 좌우 분리하여 추가
          for (let i = 0; i < maxLength; i++) {
            attendeeTableData.push({
              TBM_CD: row.sessionCd || '', // 세션코드 (참조용)
              TBM_TITLE: row.tbmTitle || '', // 교육명 (참조용)
              // 좌측 참석자
              DEP_NM1: `${leftList[i]?.depNm} / ${leftList[i]?.rank}` || '', // 소속/직책 (좌측)
              USER_NM1: leftList[i]?.userNm || '', // 성 명 (좌측)
              SIGNATURE1: leftList[i]?.signature || '', // 서 명 (좌측, base64)
              // 우측 참석자
              DEP_NM2: `${rightList[i]?.depNm} / ${rightList[i]?.rank}` || '', // 소속/직책 (우측)
              USER_NM2: rightList[i]?.userNm || '', // 성 명 (우측)
              SIGNATURE2: rightList[i]?.signature || '', // 서 명 (우측, base64)
            });
          }

          // 기존 호환성을 위해 attendeeListData에도 저장
          attendeeListData = processedAttendees;
        }

        // 2. 회의사진 base64 (첫 행은 헤더 로딩과 동일 경로면 재사용)
        let photoBase64 = '';
        if (row.entryPath) {
          if (
            index === 0 &&
            firstForHeader?.entryPath === row.entryPath &&
            headerEntryPhotoBase64
          ) {
            photoBase64 = headerEntryPhotoBase64;
          } else {
            try {
              const base64Full = await getBase64ImageSafe(row.entryPath);
              if (base64Full && base64Full.startsWith('data:image/')) {
                photoBase64 = base64Full.replace(
                  /^data:image\/[a-z]+;base64,/,
                  ''
                );
              }
            } catch (photoError) {
              console.warn('회의사진 변환 오류:', photoError);
            }
          }
        }

        const formattedRow = {
          NO: row.no || index + 1, // 순번
          TBM_TITLE: row.tbmTitle || '', // 주제
          TBM_DATE: FormatDate(row.tbmDate), // 교육일시
          EDUCATION_TIME: FormatEducationTime(row.startDt, row.endDt), // 교육시간 (시작시간 ~ 종료시간)
          TBM_ADDRESS: row.tbmAddress || '', // 교육장소
          TBM_COMMENT: row.tbmContent || '', // 회의내용
          TBM_PHOTO: photoBase64, // 회의사진 (base64)
          ATTENDEE_LIST: attendeeListData, // 참석자명단 (좌우 2컬럼 형식)
        };

        tableData.push(formattedRow);
      }

      const printData = {
        FileName: 'TRA_BASIC_02',
        HeaderData: JSON.stringify({
          YEAR: year,
          MONTH: month,
          MEETING_YEAR: meetingYear, // 회의일시 - 연도 (뒤 2자리)
          MEETING_MONTH: meetingMonth, // 회의일시 - 월
          MEETING_DAY: meetingDay, // 회의일시 - 일
          MEETING_START_TIME: meetingStartTime, // 회의일시 - 시작시간 (HH:mm)
          MEETING_END_TIME: meetingEndTime, // 회의일시 - 종료시간 (HH:mm)
          TBM_ADDRESS: firstMeetingAddress, // 회의장소
          TBM_TITLE: headerTbmTitle,
          TBM_CONTENT: headerTbmContent,
          HOST_SIGN_PATH: headerHostSignBase64,
          HOST_NM: headerHostNm,
          HOST_POSITION: headerHostRank,
          HOST_DEP_NM: hostAffiliationNm || headerHostDepNm,
          ENTRY_PATH: headerEntryPhotoBase64,
          VIDEO_FILE_NAME: headerVideoFileName,
          FILE_FILE_NAME: headerFileFileName,
          PLAN_FILE_NAME: headerPlanFileName,
        }),
        TableData: JSON.stringify(tableData), // 교육현황 테이블 데이터
        TableData2: JSON.stringify(attendeeTableData), // 참석자명단 테이블 데이터 (DEP_NM, USER_NM, SIGNATURE 컬럼)
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  // 오디오 파일 다운로드
  const DownloadLogic1 = async (audioUrl) => {
    if (!audioUrl) {
      dispatch(
        showSnackbar({
          message: '오디오 파일이 존재하지 않습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      // 1) 파일 경로 정리
      const filePath = fixUrl(audioUrl);
      const fileName = audioUrl.split('/').pop() || 'audio.mp3';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      // 2) Axios 요청 (백엔드에서 파일 내려줌)
      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 3) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 4) 가짜 <a> 태그로 다운로드 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // 5) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#endregion
  const PreviewRender = () => {
    const rowData = selectedRowData1?.[0];

    // rowData가 없으면 Hook 사용 후에도 안전하게 return
    if (!rowData) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const filePath = rowData?.entryPath || '';

    if (!filePath) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const ext = filePath.split('.').pop()?.toLowerCase();
    const fullUrl = toPreviewSrc(filePath);

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const ResetLogic1 = () => {
    setRowData1([]);
    setRowData2([]);
  };

  const PopupClickEvent1 = async (e) => {
    rowClickData.current = e;
    setSelectedRowData1([e]);
    // await loadInitialFile(e.chaebun, e.seq);
    //await SearchLogic2();
    setTimeout(() => setModalToggle1(true), 100);
  };
  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  return (
    <TRA_NEW_05
      gridId1={'grid1'}
      navigate={navigate}
      userInfo={userInfo}
      lanInfo={lanInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      rowData2={rowData2}
      setRowData2={setRowData2}
      selectedRowData2={selectedRowData2}
      setSelectedRowData2={setSelectedRowData2}
      changedRowData2={changedRowData2}
      setChangedRowData2={setChangedRowData2}
      searchRef={props.searchRef}
      filterClick5={props.filterClick5}
      setFilterClick5={props.setFilterClick5}
      searchClick5={props.searchClick5}
      setSearchClick5={props.setSearchClick5}
      addClick5={props.addClick5}
      setAddClick5={props.setAddClick5}
      saveClick5={props.saveClick5}
      setSaveClick5={props.setSaveClick5}
      deleteClick5={props.deleteClick5}
      setDeleteClick5={props.setDeleteClick5}
      printClick5={props.printClick5}
      setPrintClick5={props.setPrintClick5}
      gridRef1={gridRef1}
      gridRef2={gridRef2}
      sessionCdRef={sessionCdRef}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      lastCheckedIndexRef1={lastCheckedIndexRef1}
      selectedRowNosRef1={selectedRowNosRef1}
      deletedRowData1={deletedRowData1}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={Search1}
      SearchLogic2={Search2}
      SaveLogic1={Save1}
      PrintLogic1={PrintLogic1}
      PopupClickEvent1={PopupClickEvent1}
      PreviewRender={PreviewRender}
      DownloadLogic1={DownloadLogic1}
      RestoreRow1={deleteHandler1.RestoreRow}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
      handleRowSelection1={handleRowSelection1}
    />
  );
}

export default TRA_NEW_05F;
